// ------------------------------------
// Constants
// ------------------------------------
export const NETWORK_POLICY_ROLLBACK_PUT_REQUEST =
  "NETWORK_POLICY_ROLLBACK_PUT_REQUEST";
export const NETWORK_POLICY_ROLLBACK_PUT_REQUEST_SUCCESS =
  "NETWORK_POLICY_ROLLBACK_PUT_REQUEST_SUCCESS";
export const NETWORK_POLICY_ROLLBACK_PUT_REQUEST_FAILURE =
  "NETWORK_POLICY_ROLLBACK_PUT_REQUEST_FAILURE";
export const NETWORK_POLICY_ROLLBACK_PUT_RESET =
  "NETWORK_POLICY_ROLLBACK_PUT_RESET";

// ------------------------------------
// Actions
// ------------------------------------
export function request(id, resolve, reject) {
  return {
    type: NETWORK_POLICY_ROLLBACK_PUT_REQUEST,
    id,
    resolve,
    reject,
  };
}

export function requestSuccess(data, id) {
  return {
    type: NETWORK_POLICY_ROLLBACK_PUT_REQUEST_SUCCESS,
    data,
    id,
  };
}

export function requestFailure(error, id) {
  return {
    type: NETWORK_POLICY_ROLLBACK_PUT_REQUEST_FAILURE,
    error,
    id,
  };
}

export function reset() {
  return {
    type: NETWORK_POLICY_ROLLBACK_PUT_RESET,
  };
}
